import { api } from 'services/api/baseBackendAPI';

export const fundManagerApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Get fund manager details
    getFundManagerDetails: build.query({
      query: (requestObject) => ({
        url: `fundmanager-page/get-fund-manager`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: (result, error, requestObject) => [
        { type: 'FundManager', id: requestObject?.id || 'LIST' },
        'FundManager',
      ],
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),

    // Get company ID
    getCompanyID: build.query({
      query: (requestObject) => ({
        url: `fundmanager-page/get-company_id`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: ['Company'],
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),

    // Update fund manager details
    updateFundManagerDetails: build.mutation({
      query: (requestObject) => ({
        url: `fundmanager-page/update-fund-manager`,
        method: 'PUT',
        data: requestObject,
      }),
      invalidatesTags: (result, error, requestObject) => {
        if (error) return [];
        return [
          { type: 'FundManager', id: requestObject?.id || 'LIST' },
          'FundManager',
        ];
      },
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),

    // Update fund manager JSON
    updateFundManagerJson: build.mutation({
      query: (requestObject) => ({
        url: `fundmanager-page/update-fundmanager-json`,
        method: 'PUT',
        data: requestObject,
      }),
      invalidatesTags: (result, error, requestObject) => {
        if (error) return [];
        return [
          { type: 'FundManager', id: requestObject?.id || 'LIST' },
          'FundManager',
        ];
      },
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),

    // Get associated fund manager
    getAssociatedFundManager: build.query({
      query: (requestObject) => ({
        url: `fundmanager-page/associated-funds`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: (result, error, requestObject) => [
        { type: 'AssociatedFundManager', id: requestObject?.id || 'LIST' },
        'AssociatedFundManager',
      ],
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),

    // Get references fund manager
    getReferencesFundManager: build.query({
      query: (requestObject) => ({
        url: `fundmanager-page/get-reference-details`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: (result, error, requestObject) => [
        { type: 'References', id: requestObject?.company_id || 'LIST' },
        'References',
      ],
      transformResponse: (response) => {
        return [...response.data];
      },
      serializeQueryArgs: ({ queryArgs }) => {
        return JSON.stringify(queryArgs);
      },
    }),

    // Get portfolio fund manager
    getPortfolioFundManager: build.query({
      query: (requestObject) => ({
        url: `fundmanager-page/get-portfolio-company`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: (result, error, requestObject) => [
        { type: 'Portfolio', id: requestObject?.id || 'LIST' },
        'Portfolio',
      ],
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetFundManagerDetailsQuery,
  useGetCompanyIDQuery,
  useUpdateFundManagerDetailsMutation,
  useUpdateFundManagerJsonMutation,
  useGetAssociatedFundManagerQuery,
  useGetReferencesFundManagerQuery,
  useGetPortfolioFundManagerQuery,
} = fundManagerApi;
